import { render, staticRenderFns } from "./NotionWiki.vue?vue&type=template&id=194e4955&"
import script from "./NotionWiki.vue?vue&type=script&lang=js&"
export * from "./NotionWiki.vue?vue&type=script&lang=js&"
import style0 from "./NotionWiki.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VProgressCircular,VProgressLinear,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194e4955')) {
      api.createRecord('194e4955', component.options)
    } else {
      api.reload('194e4955', component.options)
    }
    module.hot.accept("./NotionWiki.vue?vue&type=template&id=194e4955&", function () {
      api.rerender('194e4955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotionWiki.vue"
export default component.exports